// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"tC-z","expressButtonContainerWithPayPal":"uC-z","expressButton":"vC-z","or":"wC-z"};